'use es6';

import { useEffect, useState } from 'react';
export const useVisible = (ref, rootMargin = '0px') => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    let observer;

    if (window.IntersectionObserver) {
      // eslint-disable-next-line compat/compat
      observer = new IntersectionObserver(([entry]) => setVisible(entry.isIntersecting), {
        rootMargin
      });

      if (el) {
        observer.observe(el);
      }
    } else {
      // No support for InteractionObserver, default to true
      setVisible(true);
    }

    return () => {
      if (observer) {
        observer.unobserve(el);
      }
    };
  }, [ref, rootMargin]);
  return visible;
};